<template>
  <mdb-container>
    <mdb-row>
      <mdb-col v-if="showSpinner">
        <Spinner />
      </mdb-col>
    </mdb-row>
    <mdb-row>
      <StationForm :station="stationInfo" @station-updated="onStationUpdated" />
    </mdb-row>
  </mdb-container>
</template>

<script>
import Spinner from "@/components/Spinner";
import StationForm from "@/components/StationForm";
import { mdbRow, mdbCol, mdbContainer } from "mdbvue";

export default {
  name: "StationConfig",
  components: {
    mdbRow,
    mdbCol,
    mdbContainer,
    Spinner,
    StationForm,
  },
  data() {
    return {
      stationInfo: {},
      scanLocations: [],
      scan_states: [],
      isLoading: true,
      isStationSet: !!this.$store.state.stationInfo,
    };
  },
  computed: {
    showSpinner() {
      return this.isLoading;
    },
  },
  created() {
    this.stationInfo = this.isStationSet ? this.$store.state.stationInfo : null;
    this.isLoading = false;
  },
  methods: {
    onStationUpdated(stationInfo) {
      this.$store.dispatch("setStationInfo", stationInfo);
    },
  },
};
</script>

<style scoped lang="scss"></style>
